<div class="container">
  <div class="row">
    <div class="col-2"></div>
    <div class="col-8 folat-end">
      <button type="button" class="btn btn-primary" (click)="open(content)">Add New Offer</button>
    </div>
    <div class="col-2"></div>
  </div>
  <br>
    <div class="row">
      <div class="col-2"></div>
      <div class="col-8 table-responsive text-center">
        <table class="table table-bordered">
          <thead>
            <tr class="header-color">
              <th>#</th>
              <th>Name</th>
              <th>Offer Type</th>
              <th>Offer Percentage</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @if (list_length == 0) {
              <tr>
                <td colspan="7">No data found</td>
              </tr>
            }
            @for (item of items | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; track item; let i = $index) {
              <tr
                >
                <td>{{i+1}}</td>
                <td>{{item.name}}</td>
                <td>{{item.type}}</td>
                <td>{{item.percentage}}</td>
                <td>{{item.start_date | date}}</td>
                <td>{{item.end_date | date}}</td>
                <td>
                  <div class="btn-group mr-2 btn-group-sm" role="group" aria-label="First group"
                    style="direction:ltr">
                    <button [disabled]="!utility.isAdmin()" type="button" class="btn btn-danger"
                      (click)="onDelete(item.id)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-trash" viewBox="0 0 16 16">
                        <path
                          d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                        <path fill-rule="evenodd"
                          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                      </svg>
                    </button>
                    <button type="button" class="btn btn-secondary" (click)="edit(content2, item)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-pencil-square" viewBox="0 0 16 16">
                        <path
                          d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                        <path fill-rule="evenodd"
                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
        <ngb-pagination [collectionSize]="items.length" [(page)]="page" [maxSize]="5" [rotate]="true"
        [ellipses]="false" [boundaryLinks]="false"></ngb-pagination>
      </div>
      <div class="col-2"></div>
    </div>
  </div>
  <ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Add New Offer</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label for="name">Offer Name</label>
        <input type="text" class="form-control" [(ngModel)]="item.name" id="name">
      </div>
      <div class="mb-3">
        <label for="type">Offer Type</label>
        <select class="form-select" [(ngModel)]="item.type" id="type">
          <option value='PUBLIC'>Public</option>
          <option value='PRIVATE'>Private</option>
        </select>
      </div>
      <div class="mb-3">
        <label for="percentage">Discount Percentage</label>
        <input type="number" class="form-control" [(ngModel)]="item.percentage" id="percentage">
      </div>
      @if (item.type==='PUBLIC') {
        <div class="row">
          <div class="col">
            <label for="start_date" class="form-label">Start Date</label>
            <input type="date" class="form-control" [(ngModel)]="item.start_date" id="start_date">
          </div>
          <div class="col">
            <label for="end_date" class="form-label">End Date</label>
            <input type="date" class="form-control" [(ngModel)]="item.end_date" id="end_date">
          </div>
        </div>
      }
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="OnSubmit()">Add</button>
    </div>
  </ng-template>
  <ng-template #content2 let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Update Offer</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label for="name">Offer Name</label>
        <input type="text" class="form-control" [(ngModel)]="new_item.name" id="name">
      </div>
      <div class="mb-3">
        <label for="type">Offer Type</label>
        <select class="form-select" [(ngModel)]="new_item.type" id="type">
          <option value='PUBLIC'>Public</option>
          <option value='PRIVATE'>Private</option>
        </select>
      </div>
      <div class="mb-3">
        <label for="percentage">Discount Percentage</label>
        <input type="number" class="form-control" [(ngModel)]="new_item.percentage" id="percentage">
      </div>
      @if (new_item.type==='PUBLIC') {
        <div class="row">
          <div class="col">
            <label for="start_date" class="form-label">Start Date</label>
            <input type="date" class="form-control" [(ngModel)]="new_item.start_date" id="start_date">
          </div>
          <div class="col">
            <label for="end_date" class="form-label">End Date</label>
            <input type="date" class="form-control" [(ngModel)]="new_item.end_date" id="end_date">
          </div>
        </div>
      }
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="OnUpdate(update_key)">Update</button>
    </div>
  </ng-template>